import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default class NumberBullet extends React.PureComponent {
    static propTypes = {
        /** Contents of the Bullet */
        children: PropTypes.oneOfType([PropTypes.number]),

        /** The largest number to show in the bullet. Any values larger than the max are shown as the max + */
        max: PropTypes.number,

        /** The visual appearance of the bullet */
        appearance: PropTypes.oneOf(['default', 'important']),

        /** The size of the bullet */
        size: PropTypes.oneOf(['sm', 'md', 'lg']),

        /** Inverses the color of the bullet */
        isInverse: PropTypes.bool,

        /** Adds a right margin to the number bullet */
        hasMargin: PropTypes.bool,

        /** Additional class */
        className: PropTypes.string
    };

    static defaultProps = {
        children: 0,
        max: 99,
        appearance: 'default',
        size: 'sm',
        hasMargin: true,
        isInverse: false
    };

    renderFormattedNumber() {
        let { children, max } = this.props;
        let numberToShow = 0;
        let suffix = '';

        if (typeof children !== 'number') {
            return numberToShow;
        }

        if (children < 0) {
            children = 0;
        }

        if (max < 0) {
            max = 0;
        }

        if (max && max < children) {
            numberToShow = max;
            suffix = '+';
        }
        else {
            numberToShow = children;
        }

        const formatted = numberToShow.toLocaleString('en');

        return `${formatted}${suffix}`;
    }

    render() {
        const { appearance, size, max, hasMargin, isInverse, children, className, ...rest } = this.props;

        return (
            <span
                data-component="NumberBullet"
                className={cx('sarsa-number-bullet', appearance, size, className, {
                'has-margin': hasMargin,
                'is-inverse' : isInverse
            })}
                {...rest}>
                {typeof children === 'number'
                    ? this.renderFormattedNumber()
                    : <span className="contents">{children}</span>
                }
            </span>
        );
    }
}